import { ACTION_TYPES } from 'constants'
import _ from 'lodash'

const initialState = {
  isAuthenticated: localStorage.getItem('isAuthenticated') || false,
  token: localStorage.getItem('token') || null,
}

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.AUTH: {
      // Setting values in localstorage
      if (!_.isEmpty(action?.payload?.token)) {
        localStorage.setItem(
          'isAuthenticated',
          !_.isEmpty(action?.payload?.token) ? true : false
        )
        localStorage.setItem('token', action.payload?.token)
      }
      return {
        ...state,
        // Setting values in redux
        isAuthenticated: !_.isEmpty(action?.payload?.token) ? true : false,
        token: action.payload?.token,
      }
    }
    default:
      return state
  }
}

export default AuthReducer
